import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "d",
  style: {"display":"flex"}
}
const _hoisted_3 = {
  class: "row",
  style: {"display":"flex"}
}
const _hoisted_4 = { class: "dialog-footer" }

import { Search, Refresh, Plus } from '@element-plus/icons-vue'
import { ElMessageBox, } from 'element-plus'
import type { FormInstance, } from "element-plus";
import { reactive, ref, getCurrentInstance, onMounted } from 'vue'
import { gradelist, classesList, classRoomAudioList, subjectBySchoolId, classRoomAdd, viewAudioReport } from '@/api/home'

import FileSaver from 'file-saver'



export default /*#__PURE__*/_defineComponent({
  __name: 'school_teaching_eval',
  setup(__props) {

const { proxy } = getCurrentInstance()
const { roleType, schoolId } = proxy.$store.state
let loading = ref(false)
let total = ref(0)

const queryParams = reactive({
  schoolName: '',
  teacherName: '',
  subjectCode: '',
  reportStatus: '',
  pageNum: 1,
  pageSize: 20,
  classId: '',
  gradeId: '',
  schoolId: schoolId
})

let schoolList = ref([])
const queryForm = ref<FormInstance>()

const indexMethod = (index: number) => {
  return (index + 1) + ((queryParams.pageNum - 1) * 20);

}


// 状态
const statesList = ref<
  {
    code: string
    name: string
  }[]
>([
  {
    code: '1',
    name: '已生成',
  },
  {
    code: '0',
    name: '待生成',
  },
])

const statusTypeObj = ref({
  1: '已生成',
  0: '待生成',
})


onMounted(() => {
  init()
  getList()
  getGradeList()
  getSubjectList()

})

const init = () => {
  const { id, name } = JSON.parse(localStorage.getItem('userInfo')) || {}
  if (roleType == "teacher") {
    addForm.value.teacherId = id
    addForm.value.teacherName = name
  }
}



/** 查询按钮操作 */
const handleQuery = () => {
  queryParams.pageNum = 1
  getList()
}

/** 重置按钮操作 */
const resetQuery = (form: FormInstance | undefined) => {
  if (!form) return
  form.resetFields()
  handleQuery()

}


//查询列表
const getList = async (pageNum = undefined) => {
  queryParams.pageNum = pageNum ? pageNum : 1

  let response = await classRoomAudioList(queryParams)
  if (response && response.code == 0) {
    const { totalCount, dataList } = response.data
    schoolList.value = dataList
    total.value = totalCount
  }
}
//查询学校科目
let subjectCodeOptions = ref([])
let subjectCodeObj = ref({})

const getSubjectList = async () => {
  let response = await subjectBySchoolId({ schoolId })
  if (response && response.code == 0) {
    subjectCodeOptions.value = response && response.data
    subjectCodeObj.value = getRole(response.data)
  }
}

const getRole = (list) => {
  let obj = {}
  if (!list) return {}
  list.forEach((item) => {
    obj[item.id] = item.name
  })
  return obj
}

// 只能修改添加当前班级
const classDisabled = ref(false)
let gradeList = ref([]) // 年级
let gradeClassList = ref([])  // 班级
// 年级列表
const getGradeList = async () => {
  const response = await gradelist({ schoolId });
  if (!response) return
  gradeList.value = response.data;
};

/**
* 年级切换获取班级
*/
const handleGradeSelect = async (e, classId) => {
  if (!e) return
  queryParams.classId = ''
  addForm.value.classId = classId || ''
  const response = await classesList({ schoolId, gradeId: e });
  if (response && response.code == 0) {
    gradeClassList.value = response.data.dataList
  }
}


// 添加班级

let addVisible = ref(false)
const addRef = ref<FormInstance>()
const addForm = ref<
  {
    gradeId: string | number
    classId: string | number
    topic: string
    studentNum: string | number
    classHour: string
    schoolName: string
    teacherId: string | number
    teacherName: string
    subjectCode: string | number
    audioAnnex: any
    subjectName: string
    className: string
  }>({
    gradeId: '',
    topic: '',
    classHour: '',
    studentNum: '',
    schoolName: '',
    classId: '',
    teacherId: '',
    teacherName: '',
    subjectCode: '',
    audioAnnex: {},
    subjectName: '',
    className: ''
  })

const addRules = {
  teacherId: [{ required: true, message: '请选择教师', trigger: 'blur' }],
  gradeId: [{ required: true, message: '请选择年级', trigger: 'blur' }],
  classId: [{ required: true, message: '请选择班级', trigger: 'blur' }],
  studentNum: [{ required: true, message: '请输入学生人数', trigger: 'blur' },],
  classHour: [{ required: true, message: '请输入上课时间', trigger: 'blur' },],
  topic: [{ required: true, message: '请输入课题', trigger: 'blur' },],
  subjectCode: [{ required: true, message: '请输入科目', trigger: 'blur' },],
  audioAnnex: {
    fileUrl: [{ required: true, message: '请上传音频', trigger: 'blur' }]
  }
}

const handleAdd = () => {
  // addForm.value.gradeId = activeIndex.value
  addForm.value.studentNum = ''
  addVisible.value = true
}

const fileList = ref([])
const handleUpdate = (row) => {
  const { audioAnnex } = row
  addForm.value = row
  addForm.value.gradeId = row.gradeList[0].gradeId
  addForm.value.classId = row.gradeList[0].classId
  addForm.value.subjectCode = Number(row.subjectCode)
  addVisible.value = true

  fileList.value = [{
    name: audioAnnex.fileName,
    url: audioAnnex.serverHttp + audioAnnex.fileUrl,
  }]

  handleGradeSelect(row.gradeList[0].gradeId, row.gradeList[0].classId)
  // console.log(fileList.value);

}



// 添加班级提交
const addFormSubmit = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate(async (valid, fields) => {
    if (valid) {

      let params = {
        ...addForm.value,
        classIds: [addForm.value.classId],
        schoolId
      }
      let text = params.id ? '编辑成功' : '添加成功'
      const response = await classRoomAdd(params)
      if (response && response.code == 0) {
        proxy.$msg.success(text)
        resetAddForm(formEl)
        getList()
      }
    }
  }
  )
}

/**
* 重置添加/编辑班级表单
*/
const resetAddForm = (form: FormInstance | undefined) => {
  form.resetFields()
  fileList.value = []
  addForm.value = {
    gradeId: '',
    topic: '',
    classHour: '',
    studentNum: '',
    schoolName: '',
    classId: '',
    teacherId: '',
    teacherName: '',
    audioAnnex: {},
    subjectName: '',
    className: '',
  }
  addVisible.value = false
}


let show = ref(false)
let teacherId = ref('')
// 选择教师
const handleSelect = () => {
  show.value = true
  teacherId.value = String(addForm.value.teacherId)
}
// 关闭选择教师弹窗
const closed = () => {
  show.value = false
}

// 选择教师回调
const selected = (userId, teacherName) => {
  addForm.value.teacherId = userId
  addForm.value.teacherName = teacherName
}

// 学科选择
const handleSubjectSelect = (val) => {
  if (!val) return
  let obj = subjectCodeOptions.value.find(item => item.id == val)
  addForm.value.subjectName = obj.name

}
// 班级选择
const handleClassSelect = (val) => {
  if (!val) return
  let obj = gradeClassList.value.find(item => item.id == val)
  addForm.value.className = obj.title
  addForm.value.studentNum = obj.studentNums


}


const confirmMp3 = (val) => {
  addForm.value.audioAnnex = val

}



// 查看报告

let reportVisible = ref(false)
const rowData = ref({})


const handleReport = async (row) => {

  if (!row.id) return
  const response = await viewAudioReport(row.id)
  if (response && response.code == 0) {
    reportVisible.value = true
    rowData.value = {
      ...row,
      ...response.data,
    }
  }
}

/**
* 查看报告回调函数
*/
const reportClosed = async (val) => {
  console.log(val)
  reportVisible.value = false

}
const reportConfirm = async (val) => {
  console.log(val)
  reportVisible.value = false

}



const downLoadUrl = (row) => {
  let fileUrl
  if (row.fileUrl.includes('http')) {
    fileUrl = encodeURI(row.fileUrl)
  } else {
    fileUrl = encodeURI(row.serverHttp + row.fileUrl)
  }
  if (fileUrl) {
    FileSaver.saveAs(fileUrl, row.fileName);
  }

}

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_mp3_upload = _resolveComponent("mp3-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_school_teacher_select = _resolveComponent("school_teacher_select")!
  const _component_report = _resolveComponent("report")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 12 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          class: "col-header"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, null, {
              default: _withCtx(() => [
                _createTextVNode(" 教学评价管理 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: queryParams,
          ref_key: "queryForm",
          ref: queryForm,
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "教师",
              prop: "teacherName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入教师姓名",
                  modelValue: queryParams.teacherName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.teacherName) = $event)),
                  autocomplete: "off",
                  class: "input-with-select"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "gradeId",
              label: "年级"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: queryParams.gradeId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams.gradeId) = $event)),
                  placeholder: "年级",
                  clearable: "",
                  onChange: handleGradeSelect
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gradeList), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "classId",
              label: "班级"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: queryParams.classId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams.classId) = $event)),
                  placeholder: "班级",
                  clearable: "",
                  disabled: !queryParams.gradeId
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gradeClassList), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.title,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "科目",
              prop: "subjectCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: queryParams.subjectCode,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryParams.subjectCode) = $event)),
                  placeholder: "请选择科目",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subjectCodeOptions), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "状态",
              prop: "reportStatus"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: queryParams.reportStatus,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryParams.reportStatus) = $event)),
                  placeholder: "请选择状态",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statesList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.name,
                        value: item.code
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  icon: _unref(Search),
                  type: "primary",
                  size: "mini",
                  onClick: handleQuery
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(Refresh),
                  size: "mini",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (resetQuery(queryForm.value)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(Plus),
                  type: "primary",
                  size: "mini",
                  onClick: handleAdd
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("上传课堂音频")
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _unref(schoolList),
          border: "",
          style: {"margin-bottom":"20px"},
          "header-cell-style": { background: '#FAFAFA' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "序号",
              align: "center",
              width: "120",
              type: "index",
              index: indexMethod
            }),
            _createVNode(_component_el_table_column, {
              label: "教师",
              align: "center",
              prop: "teacherName"
            }),
            _createVNode(_component_el_table_column, {
              label: "班级",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row.gradeList && row.gradeList[0] ? row.gradeList[0].gradeName +  row.gradeList[0].className :''), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "科目",
              align: "center",
              prop: "subjectName"
            }),
            _createVNode(_component_el_table_column, {
              label: "课题",
              align: "center",
              prop: "topic"
            }),
            _createVNode(_component_el_table_column, {
              label: "音频",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_button, {
                  link: "",
                  type: "primary",
                  onClick: ($event: any) => (downLoadUrl(row.audioAnnex))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 点击下载")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "学校",
              align: "center",
              prop: "schoolName"
            }),
            _createVNode(_component_el_table_column, {
              label: "报告",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(statusTypeObj.value[row.reportStatus]), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "上传时间（分）",
              align: "center",
              prop: "classHour"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              align: "center",
              width: "300"
            }, {
              default: _withCtx(({row}) => [
                (row.reportStatus == 1)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      link: "",
                      size: "small",
                      onClick: ($event: any) => (handleReport(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("预览报告")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (row.reportStatus == 0)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "primary",
                      link: "",
                      size: "small",
                      onClick: ($event: any) => (handleUpdate(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(loading)]
        ]),
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "total, prev, pager, next",
          total: _unref(total),
          "page-size": queryParams.pageSize,
          "current-page": queryParams.pageNum,
          onCurrentChange: getList
        }, null, 8, ["total", "page-size", "current-page"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(addVisible),
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(addVisible) ? (addVisible).value = $event : addVisible = $event)),
      title: "上传课堂音频",
      width: "600",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "destroy-on-close": true,
      onClosed: _cache[17] || (_cache[17] = ($event: any) => (resetAddForm(addRef.value)))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_isRef(addVisible) //@ts-ignore
 ? addVisible.value = false : addVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (addFormSubmit(addRef.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确定 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: addForm.value,
          ref_key: "addRef",
          ref: addRef,
          rules: addRules,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 16 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "教师姓名",
                      prop: "teacherId"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_el_input, {
                            type: "hidden",
                            modelValue: addForm.value.teacherId,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addForm.value.teacherId) = $event)),
                            autocomplete: "off",
                            disabled: true
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_el_input, {
                            modelValue: addForm.value.teacherName,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((addForm.value.teacherName) = $event)),
                            autocomplete: "off",
                            disabled: true
                          }, null, 8, ["modelValue"]),
                          (_unref(roleType) != 'teacher')
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                style: {"margin-left":"10px"},
                                type: "primary",
                                onClick: handleSelect
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 选择 ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "科目",
                      prop: "subjectCode"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: addForm.value.subjectCode,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((addForm.value.subjectCode) = $event)),
                          clearable: "",
                          placeholder: "请选择科目",
                          style: {"width":"100%"},
                          onChange: handleSubjectSelect
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subjectCodeOptions), (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_form_item, {
                        label: "年级班级：",
                        prop: "gradeId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: addForm.value.gradeId,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((addForm.value.gradeId) = $event)),
                            clearable: "",
                            placeholder: "请选择",
                            onChange: handleGradeSelect,
                            disabled: classDisabled.value
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gradeList), (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.gradeId,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "",
                        prop: "classId",
                        "label-width": "20px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: addForm.value.classId,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((addForm.value.classId) = $event)),
                            clearable: "",
                            placeholder: "请选择",
                            disabled: classDisabled.value || !addForm.value.gradeId,
                            onChange: handleClassSelect
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gradeClassList), (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.gradeId,
                                  label: item.title,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_el_form_item, {
                      label: "课题",
                      prop: "topic"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          placeholder: "请输入内容",
                          modelValue: addForm.value.topic,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addForm.value.topic) = $event)),
                          autocomplete: "off"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "上课时间",
                      prop: "classHour"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: addForm.value.classHour,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((addForm.value.classHour) = $event)),
                          modelModifiers: { number: true },
                          autocomplete: "off",
                          placeholder: "请输入时间（分钟）",
                          oninput: "value=value.replace(/[^0-9]/g,'')"
                        }, {
                          append: _withCtx(() => [
                            _createTextVNode("min")
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "学生人数",
                      prop: "studentNum"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: addForm.value.studentNum,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((addForm.value.studentNum) = $event)),
                          modelModifiers: { number: true },
                          autocomplete: "off",
                          placeholder: "请输入学生人数",
                          oninput: "value=value.replace(/[^0-9]/g,'')"
                        }, {
                          append: _withCtx(() => [
                            _createTextVNode("人")
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "MP3上传",
                      prop: "audioAnnex.fileUrl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_mp3_upload, {
                          onConfirm: confirmMp3,
                          fileData: fileList.value
                        }, null, 8, ["fileData"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(show))
      ? (_openBlock(), _createBlock(_component_school_teacher_select, {
          key: 0,
          teacherId: _unref(teacherId),
          onClosed: closed,
          onSelected: selected
        }, null, 8, ["teacherId"]))
      : _createCommentVNode("", true),
    (_unref(reportVisible))
      ? (_openBlock(), _createBlock(_component_report, {
          key: 1,
          visible: _unref(reportVisible),
          data: rowData.value,
          onClosed: reportClosed,
          onConfirm: reportConfirm
        }, null, 8, ["visible", "data"]))
      : _createCommentVNode("", true)
  ]))
}
}

})